// import React, { useRef, useState } from 'react';
// import AvatarEditor from 'react-avatar-editor';

// const CropperModal = ({ src, modalOpen, setModalOpen, onSave }) => {
//   const [scale, setScale] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const cropperRef = useRef(null);

//   const handleSave = async () => {
//     if (!cropperRef.current) return;

//     try {
//       setLoading(true);
//       setError(null);

//       const dataUrl = cropperRef.current.getImage().toDataURL();
//       const result = await fetch(dataUrl);
//       const blob = await result.blob();

//       // Generate a unique filename with timestamp
//       const timestamp = new Date().getTime();
//       const filename = `profile_${timestamp}.jpg`;

//       const file = new File([blob], filename, {
//         type: "image/jpeg",
//         lastModified: Date.now()
//       });

//       onSave(file);
//       setModalOpen(false);
//     } catch (err) {
//       setError('Failed to process image. Please try again.');
//       console.error('Image processing error:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!modalOpen) return null;

//   return (
//     <div className="cropper-modal-overlay">
//       <div className="cropper-modal-content">
//         {error && (
//           <div className="cropper-error">
//             {error}
//           </div>
//         )}

//         <div className="cropper-container">
//           <AvatarEditor
//             ref={cropperRef}
//             image={src}
//             width={250}
//             height={250}
//             border={50}
//             borderRadius={125}
//             color={[0, 0, 0, 0.6]}
//             scale={scale}
//             rotate={0}
//             onLoadFailure={() => setError('Failed to load image. Please try another.')}
//           />
//         </div>

//         <div className="cropper-controls">
//           <div className="zoom-control">
//             <label>Zoom:</label>
//             <input
//               type="range"
//               min="1"
//               max="3"
//               step="0.01"
//               value={scale}
//               onChange={(e) => setScale(parseFloat(e.target.value))}
//               className="zoom-slider"
//               disabled={loading}
//             />
//           </div>

//           <div className="button-group">
//             <button
//               className="cancel-button"
//               onClick={() => setModalOpen(false)}
//               disabled={loading}
//             >
//               Cancel
//             </button>
//             <button
//               className="save-button"
//               onClick={handleSave}
//               disabled={loading || error}
//             >
//               {loading ? 'Processing...' : 'Save'}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CropperModal;
import React, { useRef, useState } from "react";
import AvatarEditor from "react-avatar-editor";

const CropperComponent = ({ src, cropperRef }) => {
  const [scale, setScale] = useState(1);
  const [error, setError] = useState(null);

  return (
    <div className="cropper-inline-container">
      {error && <div className="cropper-error">{error}</div>}

      <div className="cropper-preview">
        <AvatarEditor
          ref={cropperRef}
          image={src}
          width={200}
          height={200}
          border={20}
          borderRadius={100}
          color={[0, 0, 0, 0.6]}
          scale={scale}
          rotate={0}
          onLoadFailure={() =>
            setError("Failed to load image. Please try another.")
          }
        />
      </div>

      <div className="cropper-controls">
        <div className="zoom-control">
          <input
            type="range"
            min="1"
            max="3"
            step="0.01"
            value={scale}
            onChange={(e) => setScale(parseFloat(e.target.value))}
            className="zoom-slider"
          />
        </div>
      </div>
    </div>
  );
};

export default CropperComponent;
